<template lang="pug">
v-app
  em-menu
  v-content
    v-container
      .content-area
        .desciption
          h1.display-1 Push通知管理
          p ユーザーへのPush通知の追加/編集/削除ができます
          v-layout(row, justify-center)
          v-dialog(v-model='addDialog', persistent, max-width='600px')
            template(v-slot:activator='{ on }')
              v-btn(color='primary', depressed, v-on='on') 新規追加
            v-card
              v-card-title
                span.headline Push通知登録
              v-card-text
                v-container(grid-list-md)
                  v-layout(wrap)
                    v-flex(xs12)
                      v-text-field(label='Message*', required='', v-model='push.message')
                    v-flex(xs12)
                      v-text-field(label='送信理由*', required='', v-model='push.reason')
                    v-flex(xs12)
                      el-date-picker(type="datetime", format='yyyy/MM/dd HH:mm:ss', placeholder="送信日時*", v-model='push.senddt')
                  small *indicates required field
              v-card-actions
                v-spacer
                v-btn(color='blue darken-1', flat='', @click='addDialog = false') Close
                v-btn(color='blue darken-1', flat='', @click='addPush') Save
          v-data-table.elevation-1(:headers='headers', :items='data')
            template(v-slot:items='props')
              td.text-xs {{ props.item.id }}
              td.text-xs {{ props.item.message }}
              td.text-xs {{ props.item.reason }}
              td.text-xs {{ props.item.senddt }}
              td.text-xs {{ props.item.status }}
              td.text-xs
                v-layout(row)
                  v-dialog(v-model='props.item.updateDialog', persistent, max-width='600px')
                    template(v-slot:activator='{ on }')
                      v-btn(color='warning', small, depressed, v-on='on', @click='openEditDialog(props.index)') 編集
                    v-card
                      v-card-title
                        span.headline Push情報編集
                      v-card-text
                        v-container(grid-list-md)
                          v-layout(wrap)
                            v-flex(xs12)
                              v-text-field(label='Message*', required='', v-model='push.message')
                            v-flex(xs12)
                              v-text-field(label='送信理由*', required='', v-model='push.reason')
                            v-flex(xs12)
                              el-date-picker(type="datetime", format='yyyy/MM/dd HH:mm:ss', placeholder="送信日時*", v-model='push.senddt')
                          small *indicates required field
                      v-card-actions
                        v-spacer
                        v-btn(color='blue darken-1', flat='', @click='closeEditDialog(props.index)') Close
                        v-btn(color='blue darken-1', flat='', @click='updatePush(props.index)') Save
                  v-dialog(v-model='props.item.deleteDialog', persistent, max-width='290')
                    template(v-slot:activator='{ on }')
                      v-btn(color='error', dark, small, v-on='on') 削除
                    v-card
                      v-card-title.headline 確認してください。
                      v-card-text ID: {{ props.item.id }}
                        br
                        | 本当に削除してもよろしいですか。削除をすると、元に戻すことはできません。
                      v-card-actions
                        v-spacer
                        v-btn(color='green darken-1', flat='', @click='props.item.deleteDialog = false') Cancel
                        v-btn(color='error darken-1', flat='', @click='deletePush(props.index)') Delete
</template>
<script>
import Vue from 'vue'
import API from '@/api/api.js'
import EmMenu from '@/components/organisms/EmMenu.vue'
import DisplayDataUtil from '@/utils/DisplayDataUtil'

export default {
  name: 'category',
  components: {
    EmMenu
  },
  data () {
    return {
      addDialog: false,
      push: {},
      headers: [ // テーブルのヘッダーを構造的に定義
        { text: 'ID', align: 'left', value: 'category', sortable: false },
        { text: 'Message', align: 'left', value: 'category', sortable: false },
        { text: '理由', align: 'left', value: 'category', sortable: false },
        { text: '送信日時', align: 'left', value: 'isPublish', sortable: false },
        { text: '送信ステータス', align: 'left', value: 'isPublish', sortable: false },
        { text: '', value: 'action', sortable: false }
      ],
      data: []
    }
  },
  computed: {
  },
  methods: {
    getPushList () {
      API.GetPushList().then(result => {
        this.data = []
        result.push_list.forEach((data) => {
          this.data.push({
            id: data.id,
            message: data.message,
            reason: data.reason,
            senddt: DisplayDataUtil.convertTimestampToDateFormat(data.senddt),
            status: data.status,
            updateDialog: false,
            deleteDialog: false
          })
        })
        if (this.data.length === 0) {
          this.noDataText = 'データまだ登録されていません。'
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    addPush () {
      API.AddPush({ param: this.getRequestParam() }).then(result => {
        alert('新しいPush通知が追加されました.')
        this.getPushList()
        this.addDialog = false
        this.push = {}
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    updatePush (index) {
      API.UpdatePush({ param: this.getRequestParam() }).then(result => {
        alert('ID: ' + this.data[index].id + 'が編集されました.')
        this.getPushList()
        this.data[index].updateDialog = false
        this.push = {}
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    deletePush (index) {
      let id = this.data[index].id
      API.DeletePush({ param: { id: id } }).then(result => {
        alert('ID: ' + id + 'を削除しました.\nこのPush通知は送信されません。')
        this.getPushList()
        this.data[index].deleteDialog = false
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    openEditDialog (index) {
      this.push = Vue.util.extend({}, this.data[index])
    },
    closeEditDialog (index) {
      this.data[index].updateDialog = false
      this.push = {}
    },
    getRequestParam () { // this.pushからAdd/Update用のリクエストパラメータを作成する
      return {
        id: this.push.id,
        message: this.push.message,
        reason: this.push.reason,
        senddt: DisplayDataUtil.convertTimestampToDateFormat(this.push.senddt)
      }
    }
  },
  created () {
    this.getPushList()
  }
}
</script>
<style lang="stylus" scoped>

.content-area
  display flex
  flex-direction column

</style>
